import { useParams } from '@tanstack/react-router';
import { CreateExtractionVersionFormContainer } from '../../contexts/extractions';

export function ExtractionEditPage() {
  const { extractionId } = useParams({
    from: '/authenticated/orgs/$orgSlug/extractions/$extractionId/edit',
  });

  return (
    <div className="space-y-6">
      <header className="space-y-1.5">
        <h1 className="text-[22px] font-semibold leading-tight tracking-tight text-foreground">
          New extraction version
        </h1>
        <p className="text-[13.5px] leading-relaxed text-muted-foreground max-w-2xl">
          Versions are immutable — submitting creates a new active version.
        </p>
      </header>
      <CreateExtractionVersionFormContainer extractionId={extractionId} />
    </div>
  );
}
